const COLOR_MAP: Record<string, string> = {
  bay: 'bay',
  chestnut: 'chestnut',
  gray: 'gray',
  grey: 'gray',
  black: 'black',
  'pinto white': 'pintro_white',
  palomino: 'palomino',
  buckskin: 'buckskin',
  dun: 'dun',
};

export function getHorseAvatarUrl(sex: string | null | undefined, color: string | null | undefined): string {
  const sexSuffix = sex?.toLowerCase() === 'mare' ? 'female' : 'male';
  const colorPrefix = COLOR_MAP[color?.toLowerCase()?.trim() ?? ''] ?? 'other';
  return `/horse_avatars/${colorPrefix}_${sexSuffix}.svg`;
}
